module.exports = __webpack_public_path__ + "media/images/logo-cce62838cbfa3154d8b3fae0ee0d1efe.svg";